/**
 * Wave 24 — Country SEO i18n
 * New countries: Lithuania, Rwanda, Kuwait
 * Translation gaps filled: ZH/JA/KO/SV/DA for Honduras, Jamaica, Trinidad and Tobago
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE24: CountrySEOMap = {

  lithuania: {
    fr: {
      title: 'Centre d\'appel Lituanie | Service Client FinTech | Call IT Dev',
      description: 'Centre d\'appel pour la Lituanie : agents multilingues, fuseau EET, CSAT 95%, dès 3 $/h. Capitale FinTech européenne.',
      heroTitle: 'Centre d\'appel pour la Lituanie — Support FinTech',
      heroSubtitle: 'Service client premium pour le marché lituanien. 230+ FinTechs licenciées à Vilnius.',
    },
    de: {
      title: 'Callcenter Litauen | FinTech Kundenservice | Call IT Dev',
      description: 'Callcenter für Litauen: mehrsprachige Agenten, EET-Zeitzone, CSAT 95%, ab 3 $/h. Europäische FinTech-Hauptstadt.',
      heroTitle: 'Callcenter für Litauen — FinTech Support',
      heroSubtitle: 'Premium-Kundenservice für den litauischen Markt. 230+ lizenzierte FinTechs in Vilnius.',
    },
    es: {
      title: 'Call Center Lituania | Servicio al Cliente FinTech | Call IT Dev',
      description: 'Call center para Lituania: agentes multilingües, zona EET, CSAT 95%, desde 3 $/h. Capital FinTech europea.',
      heroTitle: 'Call Center para Lituania — Soporte FinTech',
      heroSubtitle: 'Servicio al cliente premium para el mercado lituano.',
    },
    ar: {
      title: 'مركز اتصال ليتوانيا | خدمة عملاء FinTech | Call IT Dev',
      description: 'مركز اتصال لليتوانيا: وكلاء متعددو اللغات، منطقة EET، CSAT 95%، من 3 $/ساعة. عاصمة FinTech الأوروبية.',
      heroTitle: 'مركز اتصال لليتوانيا — دعم FinTech',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الليتواني.',
    },
    zh: {
      title: '立陶宛呼叫中心 | 金融科技客服 | Call IT Dev',
      description: '立陶宛呼叫中心：多语言座席，EET时区，CSAT 95%，3美元/小时起。欧洲金融科技之都。',
      heroTitle: '立陶宛呼叫中心 — 金融科技支持',
      heroSubtitle: '立陶宛市场优质客户服务。维尔纽斯230+持牌金融科技公司。',
    },
    ja: {
      title: 'リトアニアコールセンター | FinTechサポート | Call IT Dev',
      description: 'リトアニア向けコールセンター：多言語対応、EET時間帯、CSAT 95%、3$/時間〜。欧州FinTech首都。',
      heroTitle: 'リトアニア向けコールセンター — FinTechサポート',
      heroSubtitle: 'リトアニア市場向けプレミアムサービス。',
    },
    ko: {
      title: '리투아니아 콜센터 | 핀테크 고객 서비스 | Call IT Dev',
      description: '리투아니아 콜센터: 다국어 상담원, EET 시간대, CSAT 95%, 시간당 3달러부터. 유럽 핀테크 수도.',
      heroTitle: '리투아니아 콜센터 — 핀테크 지원',
      heroSubtitle: '리투아니아 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Litauen | FinTech Kundtjänst | Call IT Dev',
      description: 'Callcenter för Litauen: flerspråkiga agenter, EET-tidszon, CSAT 95%, från 3 $/h. Europas FinTech-huvudstad.',
      heroTitle: 'Callcenter för Litauen — FinTech-stöd',
      heroSubtitle: 'Premium kundtjänst för den litauiska marknaden.',
    },
    da: {
      title: 'Callcenter Litauen | FinTech Kundeservice | Call IT Dev',
      description: 'Callcenter til Litauen: flersprogede agenter, EET-tidszone, CSAT 95%, fra 3 $/t. Europas FinTech-hovedstad.',
      heroTitle: 'Callcenter til Litauen — FinTech Support',
      heroSubtitle: 'Premium kundeservice til det litauiske marked.',
    },
  },

  rwanda: {
    fr: {
      title: 'Centre d\'appel Rwanda | Service Client Bilingue EN/FR | Call IT Dev',
      description: 'Centre d\'appel pour le Rwanda : agents trilingues, fuseau CAT, CSAT 95%, dès 3 $/h. Silicon Valley de l\'Afrique.',
      heroTitle: 'Centre d\'appel pour le Rwanda — Support Trilingue',
      heroSubtitle: 'Service client premium depuis Kigali. Ville la plus smart d\'Afrique.',
    },
    en: {
      title: 'Call Center Rwanda | Bilingual Customer Service EN/FR | Call IT Dev',
      description: 'Call center for Rwanda: trilingual agents (EN/FR/Kinyarwanda), CAT timezone, CSAT 95%, from $3/hr. Africa\'s Silicon Valley.',
      heroTitle: 'Call Center for Rwanda — Trilingual Support',
      heroSubtitle: 'Premium customer service from Kigali. Africa\'s smartest city.',
    },
    de: {
      title: 'Callcenter Ruanda | Dreisprachiger Kundenservice | Call IT Dev',
      description: 'Callcenter für Ruanda: dreisprachige Agenten, CAT-Zeitzone, CSAT 95%, ab 3 $/h. Afrikas Silicon Valley.',
      heroTitle: 'Callcenter für Ruanda — Dreisprachiger Support',
      heroSubtitle: 'Premium-Kundenservice aus Kigali. Afrikas smarteste Stadt.',
    },
    ar: {
      title: 'مركز اتصال رواندا | خدمة عملاء ثلاثية اللغات | Call IT Dev',
      description: 'مركز اتصال لرواندا: وكلاء ثلاثيو اللغات، منطقة CAT، CSAT 95%، من 3 $/ساعة. وادي السيليكون الأفريقي.',
      heroTitle: 'مركز اتصال لرواندا — دعم ثلاثي اللغات',
      heroSubtitle: 'خدمة عملاء متميزة من كيغالي.',
    },
    zh: {
      title: '卢旺达呼叫中心 | 三语客服 EN/FR | Call IT Dev',
      description: '卢旺达呼叫中心：三语座席，CAT时区，CSAT 95%，3美元/小时起。非洲硅谷。',
      heroTitle: '卢旺达呼叫中心 — 三语支持',
      heroSubtitle: '基加利优质客户服务。非洲最智能城市。',
    },
    ja: {
      title: 'ルワンダコールセンター | 三言語サポート | Call IT Dev',
      description: 'ルワンダ向けコールセンター：三言語対応、CAT時間帯、CSAT 95%、3$/時間〜。アフリカのシリコンバレー。',
      heroTitle: 'ルワンダ向けコールセンター — 三言語サポート',
      heroSubtitle: 'キガリからのプレミアムカスタマーサービス。',
    },
    ko: {
      title: '르완다 콜센터 | 3개국어 고객 서비스 | Call IT Dev',
      description: '르완다 콜센터: 3개국어 상담원, CAT 시간대, CSAT 95%, 시간당 3달러부터. 아프리카의 실리콘밸리.',
      heroTitle: '르완다 콜센터 — 3개국어 지원',
      heroSubtitle: '키갈리 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Rwanda | Trespråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Rwanda: trespråkiga agenter, CAT-tidszon, CSAT 95%, från 3 $/h. Afrikas Silicon Valley.',
      heroTitle: 'Callcenter för Rwanda — Trespråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst från Kigali.',
    },
    da: {
      title: 'Callcenter Rwanda | Tresproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Rwanda: tresprogede agenter, CAT-tidszone, CSAT 95%, fra 3 $/t. Afrikas Silicon Valley.',
      heroTitle: 'Callcenter til Rwanda — Tresproget Support',
      heroSubtitle: 'Premium kundeservice fra Kigali.',
    },
  },

  kuwait: {
    fr: {
      title: 'Centre d\'appel Koweït | Service Client Arabe & Anglais | Call IT Dev',
      description: 'Centre d\'appel pour le Koweït : agents arabophones, fuseau AST, CSAT 95%, dès 3 $/h. Vision 2035.',
      heroTitle: 'Centre d\'appel pour le Koweït — Support Arabe & Anglais',
      heroSubtitle: 'Service client premium pour le Koweït. Partenaire Vision 2035.',
    },
    de: {
      title: 'Callcenter Kuwait | Arabisch-Englischer Kundenservice | Call IT Dev',
      description: 'Callcenter für Kuwait: arabischsprachige Agenten, AST-Zeitzone, CSAT 95%, ab 3 $/h. Vision 2035.',
      heroTitle: 'Callcenter für Kuwait — Arabisch-Englischer Support',
      heroSubtitle: 'Premium-Kundenservice für Kuwait. Vision 2035 Partner.',
    },
    es: {
      title: 'Call Center Kuwait | Atención Árabe e Inglés | Call IT Dev',
      description: 'Call center para Kuwait: agentes arabófonos, zona AST, CSAT 95%, desde 3 $/h. Visión 2035.',
      heroTitle: 'Call Center para Kuwait — Soporte Árabe e Inglés',
      heroSubtitle: 'Servicio al cliente premium para Kuwait.',
    },
    ar: {
      title: 'مركز اتصال الكويت | خدمة عملاء عربية وإنجليزية | Call IT Dev',
      description: 'مركز اتصال للكويت: وكلاء ناطقون بالعربية، منطقة AST، CSAT 95%، من 3 $/ساعة. رؤية الكويت 2035.',
      heroTitle: 'مركز اتصال للكويت — دعم عربي وإنجليزي',
      heroSubtitle: 'خدمة عملاء متميزة للكويت. شريك رؤية 2035.',
    },
    zh: {
      title: '科威特呼叫中心 | 阿拉伯语英语客服 | Call IT Dev',
      description: '科威特呼叫中心：阿拉伯语座席，AST时区，CSAT 95%，3美元/小时起。科威特2035愿景。',
      heroTitle: '科威特呼叫中心 — 阿拉伯语和英语支持',
      heroSubtitle: '科威特市场优质客户服务。',
    },
    ja: {
      title: 'クウェートコールセンター | アラビア語・英語サポート | Call IT Dev',
      description: 'クウェート向けコールセンター：アラビア語対応、AST時間帯、CSAT 95%、3$/時間〜。クウェートビジョン2035。',
      heroTitle: 'クウェート向けコールセンター — アラビア語・英語サポート',
      heroSubtitle: 'クウェート市場向けプレミアムサービス。',
    },
    ko: {
      title: '쿠웨이트 콜센터 | 아랍어 영어 고객 서비스 | Call IT Dev',
      description: '쿠웨이트 콜센터: 아랍어 상담원, AST 시간대, CSAT 95%, 시간당 3달러부터. 쿠웨이트 비전 2035.',
      heroTitle: '쿠웨이트 콜센터 — 아랍어 및 영어 지원',
      heroSubtitle: '쿠웨이트 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Kuwait | Arabisk & Engelsk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Kuwait: arabisktalande agenter, AST-tidszon, CSAT 95%, från 3 $/h. Kuwait Vision 2035.',
      heroTitle: 'Callcenter för Kuwait — Arabiskt & Engelskt Stöd',
      heroSubtitle: 'Premium kundtjänst för Kuwait.',
    },
    da: {
      title: 'Callcenter Kuwait | Arabisk & Engelsk Kundeservice | Call IT Dev',
      description: 'Callcenter til Kuwait: arabisktalende agenter, AST-tidszone, CSAT 95%, fra 3 $/t. Kuwait Vision 2035.',
      heroTitle: 'Callcenter til Kuwait — Arabisk & Engelsk Support',
      heroSubtitle: 'Premium kundeservice til Kuwait.',
    },
  },

  // Fill ZH/JA/KO/SV/DA gaps for Honduras
  honduras: {
    zh: {
      title: '洪都拉斯呼叫中心 | 双语客服外包 | Call IT Dev',
      description: '洪都拉斯呼叫中心：西英双语座席，CSAT 95%，3美元/小时起。中美洲BPO中心。',
      heroTitle: '洪都拉斯呼叫中心 — 双语支持',
      heroSubtitle: '中美洲市场优质客户服务。',
    },
    ja: {
      title: 'ホンジュラスコールセンター | バイリンガルサポート | Call IT Dev',
      description: 'ホンジュラス向けコールセンター：西英バイリンガル、CSAT 95%、3$/時間〜。中米BPOハブ。',
      heroTitle: 'ホンジュラス向けコールセンター — バイリンガルサポート',
      heroSubtitle: '中米市場向けプレミアムサービス。',
    },
    ko: {
      title: '온두라스 콜센터 | 이중 언어 고객 서비스 | Call IT Dev',
      description: '온두라스 콜센터: 서영 이중 언어, CSAT 95%, 시간당 3달러부터. 중미 BPO 허브.',
      heroTitle: '온두라스 콜센터 — 이중 언어 지원',
      heroSubtitle: '중미 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Honduras | Tvåspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Honduras: tvåspråkiga agenter, CSAT 95%, från 3 $/h. Centralamerikanskt BPO-nav.',
      heroTitle: 'Callcenter för Honduras — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst för centralamerikanska marknaden.',
    },
    da: {
      title: 'Callcenter Honduras | Tosproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Honduras: tosprogede agenter, CSAT 95%, fra 3 $/t. Centralamerikansk BPO-hub.',
      heroTitle: 'Callcenter til Honduras — Tosproget Support',
      heroSubtitle: 'Premium kundeservice til det centralamerikanske marked.',
    },
  },

  // Fill ZH/JA/KO/SV/DA gaps for Jamaica
  jamaica: {
    zh: {
      title: '牙买加呼叫中心 | 英语客服外包 | Call IT Dev',
      description: '牙买加呼叫中心：英语母语座席，CSAT 95%，3美元/小时起。加勒比海BPO领先者。',
      heroTitle: '牙买加呼叫中心 — 英语支持',
      heroSubtitle: '加勒比海市场优质客户服务。',
    },
    ja: {
      title: 'ジャマイカコールセンター | 英語カスタマーサポート | Call IT Dev',
      description: 'ジャマイカ向けコールセンター：英語ネイティブ、CSAT 95%、3$/時間〜。カリブ海BPOリーダー。',
      heroTitle: 'ジャマイカ向けコールセンター — 英語サポート',
      heroSubtitle: 'カリブ海市場向けプレミアムサービス。',
    },
    ko: {
      title: '자메이카 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '자메이카 콜센터: 영어 원어민, CSAT 95%, 시간당 3달러부터. 카리브해 BPO 리더.',
      heroTitle: '자메이카 콜센터 — 영어 지원',
      heroSubtitle: '카리브해 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Jamaica | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Jamaica: engelsktalande agenter, CSAT 95%, från 3 $/h. Karibisk BPO-ledare.',
      heroTitle: 'Callcenter för Jamaica — Engelsktalande Stöd',
      heroSubtitle: 'Premium kundtjänst för karibiska marknaden.',
    },
    da: {
      title: 'Callcenter Jamaica | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Jamaica: engelsktalende agenter, CSAT 95%, fra 3 $/t. Caribisk BPO-leder.',
      heroTitle: 'Callcenter til Jamaica — Engelsktalende Support',
      heroSubtitle: 'Premium kundeservice til det caribiske marked.',
    },
  },

  // Fill ZH/JA/KO/SV/DA gaps for Trinidad and Tobago
  'trinidad-tobago': {
    zh: {
      title: '特立尼达和多巴哥呼叫中心 | 英语客服 | Call IT Dev',
      description: '特立尼达和多巴哥呼叫中心：英语座席，CSAT 95%，3美元/小时起。加勒比海能源科技中心。',
      heroTitle: '特立尼达和多巴哥呼叫中心 — 英语支持',
      heroSubtitle: '加勒比海能源科技市场优质客户服务。',
    },
    ja: {
      title: 'トリニダード・トバゴコールセンター | 英語サポート | Call IT Dev',
      description: 'トリニダード・トバゴ向けコールセンター：英語対応、CSAT 95%、3$/時間〜。カリブ海エネルギーテックハブ。',
      heroTitle: 'トリニダード・トバゴ向けコールセンター — 英語サポート',
      heroSubtitle: 'カリブ海エネルギー市場向けプレミアムサービス。',
    },
    ko: {
      title: '트리니다드 토바고 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '트리니다드 토바고 콜센터: 영어 상담원, CSAT 95%, 시간당 3달러부터. 카리브해 에너지 테크 허브.',
      heroTitle: '트리니다드 토바고 콜센터 — 영어 지원',
      heroSubtitle: '카리브해 에너지 시장 프리미엄 서비스.',
    },
    sv: {
      title: 'Callcenter Trinidad och Tobago | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Trinidad och Tobago: engelsktalande agenter, CSAT 95%, från 3 $/h. Karibisk energi-tech-hub.',
      heroTitle: 'Callcenter för Trinidad och Tobago — Engelsktalande Stöd',
      heroSubtitle: 'Premium kundtjänst för karibiska energimarknaden.',
    },
    da: {
      title: 'Callcenter Trinidad og Tobago | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Trinidad og Tobago: engelsktalende agenter, CSAT 95%, fra 3 $/t. Caribisk energi-tech-hub.',
      heroTitle: 'Callcenter til Trinidad og Tobago — Engelsktalende Support',
      heroSubtitle: 'Premium kundeservice til det caribiske energimarked.',
    },
  },
};
